import { render } from "./BatchLoaderModal.vue?vue&type=template&id=7283998a&ts=true"
import script from "./BatchLoaderModal.vue?vue&type=script&lang=ts"
export * from "./BatchLoaderModal.vue?vue&type=script&lang=ts"

import "./BatchLoaderModal.vue?vue&type=style&index=0&id=7283998a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__